
import Vue from "vue";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { ILoyaltyState } from "@/store/loyalty/types";
import { LOYALTY } from "@/store/loyalty";
import { createNamespacedHelpers } from "vuex";

const { mapState } = createNamespacedHelpers(LOYALTY.NAME_SPACE);

export default Vue.extend({
  props: {
    id: {
      // Comes through as a number from the router
      // And a string if you hit the URL directly
      type: [Number, String],
      required: false
    }
  },
  data() {
    return {
      detailRouteName: LOYALTY_ROUTE_NAMES.SEGMENT_OFFER_DETAILS,
      loyaltySegmentOffersListRoute: LOYALTY_ROUTE_NAMES.SEGMENT_OFFERS
    };
  },
  computed: {
    ...mapState({
      segmentOffer: (state: ILoyaltyState) => state.segmentOffer,
      segmentName: (state: ILoyaltyState) =>
        state.segmentOffer &&
        state.segmentOffer.segment &&
        state.segmentOffer.segment.value
    })
  },
  beforeMount() {
    // Ref data needs to be loaded before the offer data
    this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CHANNEL_REFERENCE_DATA)
    );

    this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_SEGMENT_REFERENCE_DATA)
    );
  },
  async mounted() {
    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), true);

    // Do we need this?
    await this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.SET_SEGMENT_OFFER),
      {}
    );

    if (this.id) {
      await this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.LOAD_SEGMENT_OFFER),
        this.id
      );
    }

    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), false);
  }
});
